<template>
  <div
    @focusin="hasFocus = true"
    @focusout="hasFocus = false"
    class="rounded border text-sm overflow-hidden"
    :class="[{ 'bg-slate-200': disabled, 'bg-slate-50': !disabled }, error ? 'border-red-500' : hasFocus ? 'border-blue-900' : 'border-slate-300', size]">
    <slot />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  disabled: Boolean,
  error: Boolean,
  dense: Boolean,
  square: Boolean,
})

const hasFocus = ref(false)

const size = computed(() => {
  if (props.square) return 'size-6'
  if (props.dense) return 'h-[28px]'
  return 'h-[42px]'
})
</script>
